<template>
    <div class="loading text-center">
        <div class="kt-spinner kt-spinner--lg kt-spinner--brand" style="display: inline-block"></div>
    </div>
</template>

<script>
    export default {
        name: "Loading"
    }
</script>

<style scoped>
    .loading {
        display: inline-block;
        width: 100%;
        height: 70px;
    }
    .loading .kt-spinner.kt-spinner--lg:before {
        width: 35px;
        height: 35px;
        margin: 15px auto;
    }
</style>